/* eslint-disable no-debugger, no-console */

async function importFirebase() {
  const { firebase } = await import('@firebase/app');
  await import('@firebase/messaging');
  return firebase;
}

import { createApoloClient } from '@/plugins/itApolloClientFactory.js';

import registerMobileDevice from '@/api/mobileNotifications/registerMobileDevice.gql';
import unRegisterMobileDevice from '@/api/mobileNotifications/unRegisterMobileDevice.gql';

const config = {
  apiKey: 'AIzaSyB9C0X6zWOmYtkGyh-nRvI5CPZjsbLtB2A',
  authDomain: 'eamapp-cdb2e.firebaseapp.com',
  databaseURL: 'https://eamapp-cdb2e.firebaseio.com',
  projectId: 'eamapp-cdb2e',
  storageBucket: 'eamapp-cdb2e.appspot.com',
  messagingSenderId: '821491675335',
  appId: '1:821491675335:web:eefe25768f186852',
};

const publicVapidKey =
  'BP0GkrNB0-G9TIAB34kX2fkgyQt0eD04xMYUrBLNrUZ78XPiKzv_avqFfntTe0hV0qudDaz17oXBh3R-nIXMLDU';

const grapgUri = window.myConfig.GrapgQlUrl + 'api/graphql';
const notificationsApolloClient = createApoloClient(grapgUri, 'KOEEBOX', true);

export async function registerDevice() {
  try {
    const firebase = await importFirebase();
    if (firebase.apps.length && firebase.messaging.isSupported()) {
      const messaging = firebase.messaging();

      messaging
        .requestPermission()
        .then(() => {
          console.log('Notification permission granted.');

          console.log('Registering FCM token...');
          messaging.getToken().then((token) => {
            if (token) {
              console.log('Sending FCM token to server...');
              notificationsApolloClient
                .mutate({
                  mutation: registerMobileDevice,
                  variables: {
                    token: token,
                  },
                })
                .then((res) => console.log('Sent FCM token to server:' + res));
              console.log(`FCM token registered: ${token}`);
            }
          });
        })
        .catch((err) => {
          console.log('Unable to get Notification permission.', err);
        });
    }
  } catch (error) {
    console.log(error);
  }
}

export async function unregisterDevice() {
  try {
    const firebase = await importFirebase();
    if (firebase.apps.length && firebase.messaging.isSupported()) {
      console.log('Unregistering FCM token...');
      const messaging = firebase.messaging();

      await messaging.getToken().then((token) => {
        if (token) {
          notificationsApolloClient
            .mutate({
              mutation: unRegisterMobileDevice,
              variables: {
                token: token,
              },
            })
            .then((res) => console.log('Unregistered FCM token:' + res));
          console.log(`FCM token unregistered: ${token}`);
        }
      });
    }
  } catch (error) {
    console.log(error);
  }
}

export function inicializeFirebase() {
  importFirebase().then((firebase) => {
    firebase.initializeApp(config);

    if (firebase.messaging.isSupported()) {
      const messaging = firebase.messaging();

      messaging.usePublicVapidKey(publicVapidKey);

      navigator.serviceWorker
        .register(`${process.env.BASE_URL}service-worker.js`)
        .then((registration) => {
          messaging.useServiceWorker(registration);
        });
    }
  });
}
